import { styled } from '@mui/material';
import Stack from '@mui/material/Stack';

const StyledIconContainer = styled(Stack)(({ theme }) => ({
  justifyContent: 'space-around',
  height: theme.spacing(6),
}));

export default StyledIconContainer;
